import { Col, Row } from 'antd';
import { useAppSelector, useAppTranslation } from 'app/hooks';
import BigNumber from 'bignumber.js';
import Typo from 'consts/typography';
import { selectCurrentConverter } from 'features/home/homeSlice';
import { ShareBetResponseModel } from 'models';
import React, { Fragment, useMemo } from 'react';
import { platformStates } from 'redux/platformSlice';
import { isPhone, isTablet, uniqueId } from 'utils/commonUtils';
import {
  checkPlayerPropsBet,
  getMarketName,
  getMarketValue,
  getTeaserPoint,
} from 'utils/teaserUtil';

interface ShareBetTeaserProps {
  message: ShareBetResponseModel;
}

const ShareBetTeaser: React.FunctionComponent<ShareBetTeaserProps> = ({ message }) => {
  const t = useAppTranslation();
  const platform = useAppSelector(platformStates);
  const { isDesktop, isLargeDesktop } = platform;
  const colStyle1 = `col-span-3 text-white m-0 ${
    isPhone(platform) ? Typo.p7 : isTablet(platform) ? Typo.p7 : Typo.p7
  } font-medium`;
  const colStyle2 = `text-white col-span-2 m-0 ${
    isPhone(platform) ? Typo.p7 : isTablet(platform) ? Typo.p7 : Typo.p7
  } font-normal`;

  const converter = useAppSelector(selectCurrentConverter);
  const details = message.betDetails;

  const winBetAmount = useMemo(() => {
    const winAmount = new BigNumber(message.amount)
      .times(new BigNumber(message.teaserPoint?.decimalPrice))
      .minus(new BigNumber(message.amount));

    return `${winAmount} $TBET`;
  }, [message.id]);

  return (
    <div className="share-bet__container share-bet__combo">
      <Row className="my-bet__title">
        <Col flex={4}>
          <p
            className={`text-white ${
              isDesktop || isLargeDesktop ? Typo.p4 : Typo.p6
            } m-0 text-center`}
          >
            {`${t('teaserBet.title')}  (+${message.teaserPoint?.level.value})`}
          </p>
        </Col>
      </Row>
      {message.status !== 'WAITING' && (
        <Row className="mt-5 px-2">
          <span
            className={` ${
              message.status === 'WIN'
                ? 'bet-win'
                : message.status === 'LOSE'
                ? 'bet-lose'
                : 'bet-draw'
            }`}
          >
            {message.status}
          </span>
        </Row>
      )}
      {details.map((detail) => (
        <React.Fragment key={uniqueId()}>
          <>
            <Row className="mt-5 px-2">
              <span className={`text-white ${isDesktop || isLargeDesktop ? Typo.p5 : Typo.p7} m-0`}>
                {detail.homeTeam} vs {detail.awayTeam}
              </span>
            </Row>
            <Row className="mt-5 px-2">
              <div className="my-bet__content">
                {!checkPlayerPropsBet(detail.market.market) && (
                  <Fragment>
                    <p className={colStyle1}>{getMarketName(detail.market.market)}</p>
                    <p className={colStyle2}>
                      {getMarketValue(
                        detail.market.market,
                        converter,
                        detail.market.price,
                        detail.market.decimalPrice,
                        detail.market.betPoints || 0,
                        detail.market.selectionLine || '',
                      )}{' '}
                      &rArr; {getTeaserPoint(detail, message.teaserPoint?.level.value)}
                    </p>
                  </Fragment>
                )}
                {getMarketName(detail.market.market) === 'Spread' ? (
                  <>
                    <p className={colStyle1}>{detail.market?.selection}</p>
                    <p className={colStyle2}>{t('myBet.win')}</p>
                  </>
                ) : null}
              </div>
              <div className="bet-line"></div>
            </Row>
          </>
        </React.Fragment>
      ))}
      <Row className="mt-5 px-2 mb-5">
        <div className="my-bet__content">
          <p className={colStyle1}>{t('myBet.possibleWin')}</p>
          <p className={colStyle2}>{`${winBetAmount}`}</p>
          <p className={colStyle1}>{t('myBet.betAmount')}</p>
          <p className={colStyle2}>{`${message.amount} $`}</p>
        </div>
      </Row>
    </div>
  );
};

export default ShareBetTeaser;
